import Avatar from './components/Avatar';
import React from 'react';

const RefLeaderboard = ({leaderboardData}) => {
  

  return (
    <div className="ref-top-container">
      <h1>Реферальный топ</h1>
      <div className="ref-top-leaderboard">
        <div className="ref-top-scroll">
          {leaderboardData.length > 0 ? (
            <table className="ref-top-table">
              <tbody>
                {leaderboardData.map((leader, index) => (
                  <tr key={index} className="ref-top-row">
                    <td className="ref-top-user-info">
                      <span className="ref-top-user-rank">{leader.position}</span>
                      <Avatar userId={leader.id} src={leader.avatar_url} alt={leader.username} />
                      <div className="ref-top-details">
                        <span className="ref-top-username">
                          {leader.username.length > 15
                            ? leader.username.slice(0, 15) + '...'
                            : leader.username}
                        </span>
                        <span className="ref-top-clicks">
                          {leader.refs.toLocaleString()}{" "}
                          {leader.refs === 1 ? "реферал" : "рефералов"}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>Список пуст, но вы могли бы стать первым!</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RefLeaderboard;
